import React from "react";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Checkbox } from "./ui/checkbox";
import { formatPLN } from "../lib/api";

export default function SummaryCard({
  salePrice,
  totalCosts,
  onChangeSalePrice,
  disabled = false,
  // Optional payment props — only shown when provided
  showPayment = false,
  deposit = 0,
  paidInFull = false,
  onChangeDeposit,
  onChangePaidInFull,
}) {
  const profit = Number(salePrice || 0) - Number(totalCosts || 0);
  const positive = profit >= 0;
  const remaining = paidInFull
    ? 0
    : Math.max(0, Number(salePrice || 0) - Number(deposit || 0));
  return (
    <div className="surface p-6 space-y-5" data-testid="summary-card">
      <div className="heading text-lg font-semibold">Podsumowanie</div>
      <div className="space-y-1.5">
        <Label htmlFor="sale_price">Cena dla klienta (PLN)</Label>
        <Input
          id="sale_price"
          data-testid="field-sale-price"
          type="number"
          step="0.01"
          min="0"
          inputMode="decimal"
          disabled={disabled}
          placeholder="0"
          value={!salePrice ? "" : salePrice}
          onChange={(e) =>
            onChangeSalePrice(e.target.value === "" ? 0 : Number(e.target.value))
          }
        />
      </div>
      <div className="space-y-2 pt-2 border-t border-[var(--border)]">
        <Row label="Suma kosztów" value={formatPLN(totalCosts)} />
        <Row label="Cena sprzedaży" value={formatPLN(salePrice)} />
        <div className="flex items-center justify-between pt-3 mt-2 border-t border-[var(--border)]">
          <span className="text-sm font-medium text-[var(--text-muted)]">
            Zarobek na czysto
          </span>
          <span
            className={`heading text-2xl font-bold tabular-nums ${
              positive ? "text-[var(--success)]" : "text-[var(--danger)]"
            }`}
            data-testid="profit-display"
          >
            {formatPLN(profit)}
          </span>
        </div>
      </div>

      {showPayment && (
        <div className="space-y-3 pt-4 border-t border-[var(--border)]" data-testid="payment-section">
          <div className="heading text-sm font-semibold uppercase tracking-wider text-[var(--text-muted)]">
            Płatność
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="deposit">Zaliczka (PLN)</Label>
            <Input
              id="deposit"
              data-testid="field-deposit"
              type="number"
              step="0.01"
              min="0"
              inputMode="decimal"
              disabled={disabled || paidInFull}
              placeholder="0"
              value={!deposit ? "" : deposit}
              onChange={(e) =>
                onChangeDeposit?.(e.target.value === "" ? 0 : Number(e.target.value))
              }
            />
          </div>
          <div className="flex items-center justify-between pt-1">
            <span className="text-sm text-[var(--text-muted)]">Pozostało do zapłaty</span>
            <span
              className="heading text-lg font-semibold tabular-nums"
              style={{ color: remaining === 0 ? "var(--success)" : "var(--text)" }}
              data-testid="remaining-display"
            >
              {formatPLN(remaining)}
            </span>
          </div>
          <label
            className="flex items-center gap-2 pt-2 cursor-pointer select-none"
            data-testid="paid-in-full-label"
          >
            <Checkbox
              checked={paidInFull}
              disabled={disabled}
              onCheckedChange={(v) => onChangePaidInFull?.(Boolean(v))}
              data-testid="field-paid-in-full"
            />
            <span className="text-sm font-medium">Opłacono całość</span>
          </label>
        </div>
      )}
    </div>
  );
}

function Row({ label, value }) {
  return (
    <div className="flex items-center justify-between text-sm">
      <span className="text-[var(--text-muted)]">{label}</span>
      <span className="tabular-nums font-medium">{value}</span>
    </div>
  );
}
